import React, { useEffect, useState } from "react"
import {
    Card,
    CardBody,
    CardTitle,
    Col,
    Row,
    Badge,
    Button,
    UncontrolledTooltip
} from "reactstrap"
import { startCameraZoom, stopCameraZoom } from "helpers/hanwha_camera_utility"
import { RefreshCw, ZoomIn, ZoomOut, HardDrive, Database, Percent, AlertTriangle, Folder } from 'lucide-react'

// Function to map battery status to color
const getDiskStatusColor = status => {
    switch (status) {
        case "OK":
            return "success"
        case "connected":
            return "warning"
        default:
            return "danger"
    }
}

const HanwhaCameraDeviceCard = ({ camera, shouldResetZoom = false }) => {

    const [refreshPreviewKey, setRefreshPreviewKey] = useState(0);
    const [diskSpaceWarningText, setDiskSpaceWarningText] = useState("");

    const refreshPreview = () => {
        setRefreshPreviewKey(refreshPreviewKey + 1);
    }

    useEffect(() => {
        console.log("Hanwha camera id is: ", camera?.details?.id);
    }, [camera]);

    const startZoom = async (zoomValue) => {
        console.log("Starting zoom with value: ", zoomValue);
        await startCameraZoom(camera?.details?.hostname, zoomValue);
    };

    const stopZoom = async () => {
        console.log("Stopping zoom");
        await stopCameraZoom(camera?.details?.hostname);
    };

    const StatusIcon = ({ icon: Icon, id, value, tooltipText, isWarning }) => (
        <div className="d-inline-block text-center mx-2" style={{ width: '60px' }}>
            <div id={id}>
                <Icon size={24} />
                <div className={`small mt-1 ${isWarning ? "text-danger" : ""}`} style={{ wordBreak: 'break-word' }}>
                    {value}
                </div>
            </div>
            <UncontrolledTooltip target={id} placement="top">
                {tooltipText}
            </UncontrolledTooltip>
        </div>
    );

    return (
        <Card className="mb-4 border rounded shadow-sm">
            <CardBody>
                <CardTitle tag="h5" className="text-primary mb-3">
                    Camera: {camera?.details?.hostname}
                </CardTitle>
                <Row>
                    <Col xs="12">
                        <div className="position-relative" style={{ paddingBottom: '56.25%', height: 0 }}>
                            <img
                                src={`https://localhost:7001/media/E4-30-22-6A-04-49.mpjpeg?refreshKey=${refreshPreviewKey}`}
                                alt="Camera Feed"
                                className="position-absolute top-0 start-0 w-100 h-100 object-fit-cover"
                            />
                        </div>
                    </Col>
                </Row>
                <Row className="mt-2">
                    <Col xs="12" className="d-flex justify-content-between align-items-center flex-wrap">
                        <Button color="primary" size="sm" onClick={refreshPreview} className="mb-2">
                            <RefreshCw size={16} className="me-1" /> Refresh Preview
                        </Button>
                        {shouldResetZoom && (
                            <div className="mb-2">
                                <Button
                                    color="secondary"
                                    size="sm"
                                    className="me-2"
                                    onMouseDown={() => startZoom(50)}
                                    onMouseUp={stopZoom}
                                    onMouseLeave={stopZoom}
                                >
                                    <ZoomIn size={16} className="me-1" /> Zoom In
                                </Button>
                                <Button
                                    color="secondary"
                                    size="sm"
                                    onMouseDown={() => startZoom(-50)}
                                    onMouseUp={stopZoom}
                                    onMouseLeave={stopZoom}
                                >
                                    <ZoomOut size={16} className="me-1" /> Zoom Out
                                </Button>
                            </div>
                        )}
                    </Col>
                </Row>
                <Row className="mt-2">
                    <Col xs="12" className="d-flex justify-content-center align-items-start flex-wrap bg-light py-2">
                        {shouldResetZoom && (
                            <>
                                <StatusIcon
                                    icon={Folder}
                                    id="networkShare-h"
                                    value={camera?.networkShare}
                                    tooltipText="Network share location"
                                />
                              
                            </>
                        )}
                    </Col>
                </Row>
            </CardBody>
        </Card>
    )
}

export default HanwhaCameraDeviceCard